import fetchWindowObject from "@/frontend/utils/fetchWindowObject"

async function initHotjar() {
  // Initialize Hotjar
  !(function(h,o,t,j,a,r){
    h.hj = h.hj || function() { (h.hj.q = h.hj.q || []).push(arguments) }
    h._hjSettings = { hjid: 471554, hjsv: 6 }
    a = o.getElementsByTagName('head')[0]
    r = o.createElement('script')
    r.async = 1
    r.src = t + h._hjSettings.hjid + j + h._hjSettings.hjsv
    a.appendChild(r)
  })(window, document, 'https://static.hotjar.com/c/hotjar-', '.js?sv=')

  const { userID, userRole, railsEnv } = window.config

  if (!userID) return

  const hjObject = await fetchWindowObject("hj")

  hjObject('identify', userID, {
    id: userID,
    user_type: userRole,
    environment: railsEnv
  })
}

initHotjar()
